module.exports = __webpack_public_path__ + "img/hangzhou-map.58b896a4.png";